import { call, put, takeLatest } from "redux-saga/effects";

import { PatientsAPI } from "../../../api/patientsAPI";
import {
  GET_PATIENT_SCHEDULES_REQUEST,
  GET_PATIENT_SCHEDULES_SUCCESS,
  GET_PATIENT_SCHEDULES_ERROR
} from "../../actions";

function* workerGetPatientSchedules({
  type,
  payload: { patientId },
}: {
  type: string;
  payload: {
    patientId: any;
  };
}): Generator<any> {
  try {
    const data: any = yield call(PatientsAPI.getPatientSchedules, patientId);

    yield put({
      type: GET_PATIENT_SCHEDULES_SUCCESS,
      payload: { schedules: data }
    });
  } catch (error: any) {
    yield put({
      type: GET_PATIENT_SCHEDULES_ERROR,
      payload: { code: error.response.status, message: error.message }
    });
  }
}

export function* watcherGetPatientSchedules() {
  yield takeLatest(GET_PATIENT_SCHEDULES_REQUEST, workerGetPatientSchedules);
}
